<template>
  <div class="test_case border-dashed border border-2 p-6">
    <div class="font-bold text-lg flex justify-between items-end">
      <span> Large Test Case {{ index + 1 }} </span>
      <button
        class="border border-1 border-grey-light h-8 w-8 text-red bg-white hover:text-white hover:bg-red p-0"
        @click="$emit('REMOVE_TEST_CASE')"
      >
        <span>✖</span>
      </button>
    </div>

    <div class="form_group">
      <div class="form_field">
        <input
          :id="`display_input_${index + 1}`"
          v-model="item.visible"
          type="checkbox"
        />
        <label :for="`display_input_${index + 1}`">Visible?</label>
      </div>
      <div class="form_field">
        <input
          :id="`is_required_${index + 1}`"
          v-model="item.is_required"
          type="checkbox"
        />
        <label :for="`is_required_${index + 1}`">Required?</label>
      </div>
      <div class="form_field flex-col items-start">
        <label :for="`testcase_points_${index + 1}`">Points:</label>
        <input
          :id="`testcase_points_${index + 1}`"
          v-model.number="item.points"
          type="number"
        />
      </div>
    </div>

    <div class="test_case_file_uploads">
      <div class="file_upload">
        <div class="mb-1">Large In #{{ index + 1 }}</div>
        <SingleFileUpload
          :maxFileSize="maxFileSize"
          @codingFileUploadFail="handleFileUploadFailure"
          @codingFileUploadSuccess="
            catchSubmissionCaseLargeInUploadEvent($event, item)
          "
        />
        <div
          v-if="item.large_in && item.large_in.length > 2"
          class="file_id"
          @click="emitOpenFileEvent(item.large_in)"
        >
          <strong>File ID: </strong>
          <span class="link">{{ item.large_in }}</span>
        </div>
      </div>
      <div class="file_upload">
        <div class="mb-1">Large Out #{{ index + 1 }}</div>
        <SingleFileUpload
          @codingFileUploadFail="handleFileUploadFailure"
          @codingFileUploadSuccess="
            catchSubmissionCaseLargeOutUploadEvent($event, item)
          "
        />
        <div
          v-if="item.large_out && item.large_out.length > 2"
          class="file_id"
          @click="emitOpenFileEvent(item.large_out)"
        >
          <strong>File ID:</strong>
          <span class="link">{{ item.large_out }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SingleFileUpload from "@/components/shared/fileUpload/SingleFileUpload"

export default {
  components: {
    SingleFileUpload,
  },
  props: ["item", "index"],
  data() {
    return {
      // nginx default POST client payload size is 1MB
      // we are limiting upload to about 800KB here
      maxFileSize: 800 * 1024,
    }
  },
  methods: {
    emitOpenFileEvent(id) {
      this.$emit("OPEN_MODAL_CONTENT", id)
    },
    catchSubmissionCaseLargeInUploadEvent($event, submissionCase) {
      submissionCase.large_in = $event.id
    },
    catchSubmissionCaseLargeOutUploadEvent($event, submissionCase) {
      submissionCase.large_out = $event.id
    },
    handleFileUploadFailure(message) {
      alert(`File upload failed! ${message}`)
    },
  },
}
</script>

<style scoped>
.test_case {
  display: grid;
  border-radius: 0.5rem;
  background: #fdfdfd;
  gap: 2.5rem;
}

.test_case:hover {
  border-color: rgba(0, 0, 0, 0.4);
  background: rgba(0, 0, 0, 0.02);
}

.form_group {
  display: flex;
  max-width: 50ch;
  gap: 1rem;
  justify-content: space-between;
  align-items: flex-end;
}

.form_field {
  display: flex;
  gap: 0.5rem;
}

label,
input {
  display: inline-block;
  margin: 0;
  padding: 0;
  font-size: 1rem;
}

input {
  max-width: 10ch;
  padding: 0.25rem 0.5rem;
}

.test_case_file_uploads {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 1.5rem;
}

.file_upload {
  display: grid;
  gap: 0.25rem;
}

.file_id {
  font-size: 0.9rem;
}

strong {
  color: #555;
}
span.link {
  color: #555;
}
span.link:hover {
  color: #111;
  text-decoration: underline;
}
</style>
